import { useMemo } from 'react'
import { BaseTable } from 'Features/Table/BaseTable.view'
import { ExtendedGridColDef } from 'Features/Table/BulkUpdateModal'
import { SheduleTableProps, SteriliserTypesRowType } from './Scheduler.types'
import { Box } from '@mui/material'

const dataConfig = {
  required: [
    'steriliserTypeId',
    'cycleHours',
    'instanceCount',
    'basketsPerCycle',
  ],
  optional: [],
}

export const SchedulerSteriliserTypesTable = ({
  data,
  isLoading,
  updateTableData,
  uploadScheduleData,
  isUploading,
  isSaving,
  updateRowsStatus,
  predicate,
  deleteTableData,
  isDeleting,
  readOnly = false,
}: SheduleTableProps<SteriliserTypesRowType>) => {
  const handleDataUpdate = (
    changedRows: Record<number, SteriliserTypesRowType>
  ) => {
    updateTableData(changedRows)
  }

  const columns: ExtendedGridColDef[] = useMemo(
    () => [
      {
        headerName: 'Steriliser Type',
        field: 'steriliserTypeId',
        type: 'string',
        flex: 1,
        editable: true,
      },
      {
        headerName: 'Cycle Time (h)',
        field: 'cycleHours',
        type: 'number',
        flex: 1,
        editable: true,
      },
      {
        headerName: 'Instances',
        field: 'instanceCount',
        type: 'number',
        flex: 1,
        editable: true,
      },
      {
        headerName: 'Baskets / Cycle',
        field: 'basketsPerCycle',
        type: 'number',
        flex: 1,
        editable: true,
      },
    ],
    []
  )

  return (
    <Box>
      <BaseTable
        data={data ?? []}
        columns={columns}
        isLoading={isLoading}
        updateTableData={handleDataUpdate}
        uploadData={uploadScheduleData}
        isUploading={isUploading}
        isSaving={isSaving}
        checkBoxSelection={true}
        showTableToolBar={true}
        readOnly={readOnly}
        downloadFileName="SchedulerSteriliserTypes"
        onDeleteRows={readOnly ? undefined : deleteTableData}
        isDeleting={isDeleting}
        multiStageUpload={{
          uploadFile: uploadScheduleData,
          isUploading: isUploading,
          columns: columns,
          updateRowsStatus: updateRowsStatus,
          originalData: data,
          predicate: predicate,
          dataConfig: dataConfig,
        }}
        initialState={{
          pagination: { paginationModel: { pageSize: 100 } },
        }}
        sx={{
          maxWidth: 'calc(100vw - 70px)',
          '& .MuiDataGrid-cell--editable': {
            backgroundColor: '#CBD5E1',
          },
          '& .MuiBox-root': {
            padding: '0px !important',
          },
        }}
      />
    </Box>
  )
}
